import React, {useState} from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import JudulForm from 'components/componentsmall/nav_judul'
import FormInput from 'components/componentsmall/form_input'
import FormPass from 'components/componentsmall/form_pass'
import {Link, useHistory} from 'react-router-dom'
import swal from 'sweetalert';
import './style.css'

export default function Daftar(props) {
    const [full_name, setFull_name] = useState("")
    const [phone_number, setPhoneNumber] = useState("")
    const [password, setPassword] = useState("")
    const [password_confirmation, setPassword_confirmation] = useState("")
    const history = useHistory()
   

    async function daftar () {
        let item = {phone_number,full_name, password, password_confirmation}
        if(password !== password_confirmation) {
            swal({text:"maaf! periksa kembali password anda", icon:"error"})
        } else if(full_name === "") {
            swal({text:"maaf! kolom wajib di isi", icon:"error"})
        } 
        else {
        let result = await fetch(`https://supplier.malmora.com/api/reseller/register`, {
            method: "POST",
            body:JSON.stringify(item),
            headers: {
                "Content-Type":"application/json",
                "Accept":"application/json"
            }
        })
        if(!result.ok) {
             swal({text:"maaf no hp atau password anda masukkan tidak valid!", icon:"error"})
         } else {
             swal({text:"mantap", icon:"success"})
            history.push("/dashboard")
         }
        
    }
    }
    return (
        <>
            <div className="form-signup">
                <div className="form-content">
                <JudulForm />
                     <Container>
                        <Row className="d-flex justify-content-between">
                            <Col md={5}>
                                <div className="form-daftar">
                                    <div className="title-daftar">
                                        <Link to="/"><img src="asset/home/icons/back.svg" alt="back" /></Link>
                                        <h3>Daftar dengan Nomor HP</h3>
                                    </div>
                                    <div className="form-input-group">
                                        <FormInput cLable="lable-daftar" value={phone_number} id="phone" onChange={(e)=>setPhoneNumber(e.target.value)} lable="No HP" type="text" place="No HP anda" />
                                        <FormInput cLable="lable-daftar" value={full_name} onChange={(e) => setFull_name(e.target.value)} lable="Nama Lengkap" type="text" place="Nama lengkap anda" />
                                        <FormPass cLablePass="lable-daftar" value={password} onChange={(e) => setPassword(e.target.value)} lablePass="Kata Sandi Anda" placePass="Kata sandi anda" />
                                        <FormPass cLablePass="lable-daftar" value={password_confirmation} onChange={(e) => setPassword_confirmation(e.target.value)} lablePass="Konfirmasi Kata Sandi" placePass="Ketik ulang kata sandi anda" />
                                        <p className="mt-4">Dengan mendaftar, saya menyutujui <span>Syarat dan Ketentuan</span> serta <span>Kebijakan Privasi.</span></p>
                                        <FormInput cName="selanjutnya" type="button" onClickInput={daftar} value="Daftar"/>
                                    </div>
                                </div>             
                            </Col>
                            <Col md={6} className="column-signup-img">
                                <img src="asset/home/img-daftar.png" alt="daftar" />
                                <p className="text-img">Menjadi Reseller lebih mudah dengan menggunakan <span>Malmora</span></p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <br /><br /><br /><br />
          <div className="text-span">
                2020 Malmora
          </div>
        </>
    )
}
